module.exports = __webpack_public_path__ + "img/teacher-home-fondo.264a8dae.svg";